import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { COMPLETE_AWARD, GET_MY_AWARDS } from "../api/queries";
import { graphQLClient } from "../graphqlClient";
import { useCurrentUser } from "./useCurrentUser";
import { useReactQueryErrorReporter } from "./use-error-reporter";

export const useGetMyAwards = () => {
  const { error, data, ...rest } = useQuery({
    queryKey: ["awards"],
    queryFn: async () => {
      const resp = await graphQLClient.request(GET_MY_AWARDS);
      return resp.getAwards;
    },
  });

  useReactQueryErrorReporter("Error fetching awards", error, false);

  return { ...rest, error, data: data || [] };
};

export const useCompleteAward = () => {
  const currentUser = useCurrentUser();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ awardId, awardType }) => {
      const { completeAward } = await graphQLClient.request(COMPLETE_AWARD, {
        input: {
          awardId,
          awardType,
          shardID: currentUser.shardID,
          userPath: currentUser.userPath,
        },
      });
      return completeAward;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["awards"] });
    },
  });

  return { completeAward: mutation };
};
